<template>
  <div>
    <div v-if="itemd!==undefined">
      <b-nav-item-dropdown v-if="itemd.hijos.length>0" menu-class="top animate slideIn">
        <template slot="button-content">
          <i :class="'icon-' + itemd.clase"></i>
          {{ itemd.titulo }}
        </template>
        <b-dropdown-item
          v-for="hijo in itemd.hijos.filter(p=> p.visible === true)"
          :key="hijo.idopcion"
          v-on:click="seleccionar(hijo.idopcion)"
        >{{ hijo.titulo }}</b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item v-else link-classes="pl-0" v-on:click="seleccionar(itemd.idopcion)">
        <i :class="'icon-' + itemd.clase"></i>
        {{ itemd.titulo }}
      </b-nav-item>
    </div>
    <div v-else>
      <p>Hola mundo</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "navitem",
  data() {
    return {
      itemd: null
    };
  },
  props: {
    idopcion: {}
  },
  computed: {
    ...mapGetters(["gopciones", "gopciones_padre"])
  },
  created() {
    this.itemd = this.gopciones.filter(p => p.idopcion === this.idopcion)[0];
  },
  methods: {
    seleccionar(btn) {
      let opcion = this.gopciones.filter(p => p.idopcion == btn)[0];
      if (opcion.link !== null) {
        alert(opcion.link);
        if (opcion.link.toUpperCase().includes("REPORTE_")) {
          let cad = opcion.link.replace("REPORTE_", "");
          let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
          let env = global[global.env];
          this.$aes.setKey(env.path.secret);
          let cifra = this.$aes.encrypt(cad);
          this.$router.push("/reporte/" + cifra);
        } else {
          if (!opcion.link.toUpperCase().includes("HTTP")) {
            this.$router.push(opcion.link);
          } else {
            window.open(opcion.link, "_blank");
          }
        }
      }
    }
  }
};
</script>